import { prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { User } from "../../users/_types/user";
import { CaseNote } from "../../cases/_types/case-note";
import { File } from "../../common/_types/file";
import { Contract } from "../../companies/_types/contract";
import { Company } from "../../companies/_types/company";
import { Template } from "./template";

export class TemplateContracts extends Resource {
    public override type = 'templateContracts';

    @prop()
    @required()
    public templateId?: string;
    public template!: Template;
    
    @prop()    
    public contractId?: string;
    public contract!: Contract;
    

    @prop()
    public companyId?: string;
    public company!: Company;

}